<template>
  <div class="row">
    <div class="col-lg-4">
      <div class="sidebar-left w-100">
        <div class="sidebar">
          <div
              class="sidebar-content w-100"
          >
            <!-- Header -->
            <div class="chat-fixed-search w-100">
              <div class="d-flex align-items-center w-100">
                <!-- Search -->
                <b-input-group class="input-group-merge w-100 round">
                  <b-input-group-prepend is-text>
                    <feather-icon
                        icon="SearchIcon"
                        class="text-muted"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                      v-model="searchQuery"
                      placeholder="Поиск..."
                  />
                </b-input-group>
              </div>
            </div>

            <!-- ScrollArea: Chat & Contacts -->
            <vue-perfect-scrollbar
                :settings="perfectScrollbarSettings"
                class="chat-user-list-wrapper list-group w-100 scroll-area"
            >

              <!-- Chats Title -->
              <h4 class="mt-4 chat-list-title">
                Учителя
              </h4>

              <!-- Chats -->
              <ul class="chat-users-list chat-list media-list">
                <li v-for="teacher in teachersWithGroup"
                    @click="chooseTeacher(teacher.id)"
                    class="chat-info flex-grow-1"
                    :class="{'active': teacher.id === activeTeacherId}"
                >
                  <h5 class="mb-0">
                    {{ teacher.name }} - {{ teacher.email }}
                  </h5>
                  <p class="card-text text-truncate">
                  </p>
                </li>
              </ul>
            </vue-perfect-scrollbar>
          </div>

        </div>
      </div>
    </div>
    <div v-if="activeTeacher" class="col-lg-8">
      <div v-for="group in activeTeacher.my_groups">
        <h4>
          Название группы - {{group.name}}
        </h4>
        <h4>
          Описание группы - {{group.description}}
        </h4>
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea,
  BInputGroup,
  BInputGroupPrepend
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import WorkingHoursInput from "@/components/TeacherSchedule/WorkingHoursInput";
import {createNamespacedHelpers} from 'vuex'
import CRMApi from '@/api/crm';
import formattedDate from '@/mixins/formattedDate'


const {mapState, mapActions, mapGetters} = createNamespacedHelpers('crm')

export default {
  components: {
    WorkingHoursInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormGroup,
    BInputGroupPrepend,
    BFormInput,
    BInputGroup,
    BButton,
    VuePerfectScrollbar
  },
  mixins: [formattedDate],
  name: "index",
  computed: {
    ...mapState({
      teachers: state => state.teachers
    }),
    ...mapGetters(['teachersWithGroup']),
  },
  data() {
    return {
      form: {},
      chosenDays: [],
      filledTime: {},
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
      searchQuery: '',
      activeChatContactId: '',
      activeTeacher: null,
      studentData: {},
      activeTeacherId: 0,
    }
  },
  methods: {
    ...mapActions(['getUsers']),
    chooseTeacher(id) {
      const teacher = this.teachers.find(teacher => teacher.id === id)
      this.activeTeacher = teacher
      this.activeTeacherId = teacher.id
    }
  },
  created() {
    this.getUsers();
  }
}
</script>

<style lang="scss" scoped>
.chat-users-list {
  height: 80vh;
  padding-left: 0;
  list-style-type: none;

  .chat-info {
    padding: 10px;
    cursor: pointer;
    &.active{
      background: #ffbd3b;
      h5{
        color: #fff;
      }
    }
  }
}

.dark-layout {
  .chat-fixed-search {
    background-color: #283046;
  }

  .chat-user-list-wrapper {
    background-color: #283046;
  }
}
</style>
